<router-outlet>
  <aside class="center blank blank-{{slug}}">
    <img src="{{imagesOthers}}logo.svg" alt="logo">
  </aside>
</router-outlet>
